import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { Item, IToDoRequest, IToDoResponse } from '../models/todos.model';
import { fromGetToDoAction } from '../actions';
import * as fromTabIndex from '../actions';

export const todoFeatureKey = 'todolist';

export interface ToDoListState {
  loadToDoListRequest: IToDoRequest;
  loadToDoListResponse: IToDoResponse;
  loadToDoListFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
  tabIndex: number;
}

export const initialState: ToDoListState = {
  loadToDoListFailure: undefined,
  loadToDoListRequest: undefined,
  loadToDoListResponse: undefined,
  loaded: undefined,
  tabIndex: 0
};

export const reducer = createReducer(
  initialState,

  on(fromGetToDoAction.loadTodos, (state, action) => ({
    ...state,
    loadToDoListRequest: action.request
  })),
  on(fromGetToDoAction.loadTodosSuccess, (state, action) => ({
    ...state,
    loadToDoListResponse: action.response,
    loaded: true
  })),
  on(fromGetToDoAction.loadTodosFailure, (state, action) => ({
    ...state,
    loadToDoListFailure: action.error
  })),
  on(fromGetToDoAction.clearToDos, (state, action) => ({
    ...state,
    loadToDoListResponse: undefined,
    loaded: false
  })),
  on(fromTabIndex.loadLegalEntityTabControls, (state, action) => ({
    ...state,
    tabIndex: action.tabIndex
  }))
);

export const getLegalEntityTabControlsIndex = (state: ToDoListState) => state.tabIndex;

export const getToDoRequest = (state: ToDoListState) => state.loadToDoListRequest;
export const getToDoResponse = (state: ToDoListState) => {
  if (state.loadToDoListResponse !== undefined) {
    var itemCopy: Item[] = [];

    itemCopy = [...state.loadToDoListResponse.items];
    var result = itemCopy.sort(function (a: any, b: any) {
      return b.isShowStopper - a.isShowStopper;
    });
    var responseCopy = { ...state.loadToDoListResponse };
    responseCopy.items = result;
    return responseCopy;
  }
};
export const getToDoFailure = (state: ToDoListState) => state.loadToDoListFailure;

export const getToDoIsLoaded = (state: ToDoListState) => state.loaded;
